import { Shimmer } from './Shimmer'

export default Shimmer
